
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/affiliate-settings",
      function () {
        return require("private-next-pages/profile/affiliate-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/affiliate-settings"])
      });
    }
  